/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getPeriodTypeByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetPeriodTypeById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getPeriodTypeByIdIdRegExpTwo)]).optional()
});

export type GetPeriodTypeById = zod.input<typeof GetPeriodTypeById>;
export type GetPeriodTypeByIdOutput = zod.output<typeof GetPeriodTypeById>;
